import React, { useState, useEffect, useRef } from 'react';
import {
  KeyboardTimePicker,
  KeyboardTimePickerProps,
} from '@material-ui/pickers';
import { withStyles } from '@material-ui/core';

import { ParsableDate } from '@material-ui/pickers/constants/prop-types';
import { ExtendMui } from '@material-ui/pickers/typings/extendMui';
import { dVariant } from 'main_consts';

// onchange example----------------------------------------------------
// export const DatePickerChange = UpdateData => (name, dateFormat: (IdateFormat | string[]) = dDaFormat) => date => {
//     if (isArray(name) && isArray(dateFormat) && name.length === dateFormat.length) {
//         const updateObj = {};
//         name.forEach((obj, idx) => updateObj[name[idx]] = daFormatTrans(date, dateFormat[idx] as IdateFormat))
//         UpdateData(updateObj)
//     }
//     else {
//         UpdateData({ [name]: daFormatTrans(date, dateFormat as IdateFormat) });
//     }
//     return null
// }

// const----------------------------------------------------
export const EmptyDateMsg = '請填寫這個欄位。';

interface ICustomProps {
  required?: boolean;
  verifyBeforeChange?: boolean;
  verifiers?: Iverifier[];
}

interface Iverifier {
  func: (value: ParsableDate) => boolean;
  text: string;
}

// html required 無效，因為 input readonly
const StyleTimePicker = withStyles({
  root: {
    '& .MuiInputBase-formControl': {
      padding: 0,
      '& input': {
        padding: '0.675em 0 0.675em 0.75em',
        // fontSize: '1.15em',
      },
      '& input:disabled': {
        padding: '0.675em 0.75em',
      },
    },
  },
})(KeyboardTimePicker);
interface ITimePickerTyping
  extends Omit<ExtendMui<KeyboardTimePickerProps>, 'onClose'>,
    ICustomProps {
  onClose?: (date: Date | null) => void;
}
const TimePickerTyping = (props: ITimePickerTyping): JSX.Element => {
  const {
    value,
    onChange,
    onClose,
    error,
    helperText,
    verifiers = [],
    verifyBeforeChange = false,
    required,
    className,
    disabled,
    clearable = true,
    ampm = false,
    ...other
  } = props;
  const [message, setMessage] = useState<string | undefined>();
  const [FirstVerify, setFirstVerify] = useState(verifyBeforeChange);

  const dateRef = useRef(value);
  useEffect(() => {
    dateRef.current = value;
  }, [value]);

  if (required) {
    verifiers.push({ func: (date) => !date, text: EmptyDateMsg });
  }

  useEffect(() => {
    // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
    if (!FirstVerify) {
      setFirstVerify(true);
      setMessage(undefined);
      return;
    }

    // 驗使用者設定之 verifier, 空值也要驗(不能驗 HTML validation)
    // input 為 readonly or hidden 時，不會觸發
    if (verifiers.length > 0) {
      const veriObj = verifiers.find((obj) => obj.func(value));
      if (veriObj) {
        setMessage(veriObj.text);
        return;
      }
    }
    // 先前檢驗都 pass
    setMessage(undefined);
  }, [value, verifyBeforeChange]);

  const errorAttr = error || (message || '').length > 0;
  const helperTextAttr = message || helperText;
  return (
    <div className={className} style={{ width: '100%' }}>
      <StyleTimePicker
        disabled={disabled}
        clearable={clearable}
        ampm={ampm}
        value={value}
        style={{ width: '100%' }}
        inputVariant={dVariant}
        {...(errorAttr && { error: errorAttr })}
        {...(helperTextAttr && { helperText: helperTextAttr })}
        onChange={(d) => {
          dateRef.current = d;
          if (onChange) {
            onChange(d);
          }
        }}
        onClose={() => {
          if (onClose) {
            onClose(dateRef.current as Date | null);
          }
        }}
        invalidDateMessage="無效的時間格式"
        okLabel="確認"
        cancelLabel="取消"
        clearLabel="清除"
        todayLabel="今日"
        {...other}
      />
    </div>
  );
};

export default TimePickerTyping;
